import { FETCH_INTEGRATION_REGISTRY } from '../actions/Types';

const initialState = {
  items: [],
  item: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_INTEGRATION_REGISTRY:
      return {
        ...state,
        items: action.payload,
      };
    default:
      return state;
  }
}
